// Import Firebase
import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  deleteToken,
  Messaging,
} from "firebase/messaging";
import CacheStorage from "../storage/CacheStorage";
import StorageKeys from "../../const/StorageKeys";
import { isMobile } from "react-device-detect";
import UtilityHelper from "../utilities/UtilityHelper";

// Your Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_firebase_api_key,
  authDomain: process.env.REACT_APP_firebase_auth_domain,
  projectId: process.env.REACT_APP_firebase_project_id,
  storageBucket: process.env.REACT_APP_firebase_storage_bucket,
  messagingSenderId: process.env.REACT_APP_firebase_messaging_sender_id,
  appId: process.env.REACT_APP_firebase_app_id,
  measurementId: process.env.REACT_APP_firebase_measurement_id,
};

const app = initializeApp(firebaseConfig);
let messaging: Messaging | null = null;

const browerAgentNane = UtilityHelper.getBrowerAgent();
if (!isMobile && typeof window !== "undefined") {
  if (browerAgentNane !== "safari") {
    messaging = getMessaging(app);
  }
}

// Add this inside an async function
export const getFCMToken = async (): Promise<string> => {
  console.log(messaging);
  if (messaging != null) {
    try {
      const currentToken = await getToken(messaging, {
        vapidKey: process.env.REACT_APP_firebase_public_vapid_key,
        serviceWorkerRegistration: await navigator.serviceWorker.register(
          "/firebase-messaging-sw.js"
        ), // 👈 important
      });

      if (currentToken) {
        console.log(`FCM Token: ${currentToken}`);
        CacheStorage.saveValue(StorageKeys.device_token, currentToken);
        return currentToken;
        // Send it to your backend to store and use later
      } else {
        console.log(
          "No registration token available. Request permission to generate one."
        );
        return "";
      }
    } catch (err) {
      console.error("An error occurred while retrieving token. ", err);
      return "";
    }
  }

  return "";
};
//getFCMToken()

export const removeFCMToken = async () => {
  if (messaging != null) {
    try {
      const success = await deleteToken(messaging);
      if (success) {
        console.log("FCM token deleted successfully.");
        // Optionally inform your backend to remove the token
      } else {
        console.log("No token to delete.");
      }
    } catch (error) {
      console.error("Unable to delete FCM token.", error);
    }
  }
};

//removeFCMToken();

export const logout = async () => {
  await removeFCMToken();
  // Continue with logout logic
};
